import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router }                 from '@angular/router';
import { Http }                   from '@angular/http';
import { AuthService }            from '../shared/auth.service';
import { FormControl,
         FormBuilder,
         FormGroup,
         Validators }             from '@angular/forms';
import { JwtHelper }              from 'angular2-jwt';
import { LoginModel, PortalTypeEnum } from './login.model';
import { Globals }                from '../common/globals';

const styles   = require('./login.component.scss');
const template = require('./login.component.html');

@Component({
  selector: 'sa-login',
  template: template,
  styles: [ styles ]
})
export class LoginComponent implements AfterViewInit {
  public loginForm: FormGroup;
  public errorMessage: string = null;
  public jwtHelper: JwtHelper = new JwtHelper();
  public inProgress = false;

  public selectedPortalType: PortalTypeEnum;

  public portalTypes = PortalTypeEnum;

  constructor(public router: Router,
            public http: Http,
            private authService: AuthService,
            private formBuilder: FormBuilder,
            private globals: Globals,
            private changeDetectionRef: ChangeDetectorRef) {
    if (this.loggedIn()) {
        this.router.navigate(['/monitoring']);
    }

    this.loginForm = this.formBuilder.group({
            Username: new FormControl('', Validators.required),
            Password: new FormControl('', Validators.required),
            RememberMe: new FormControl(),
            PortalType: new FormControl(PortalTypeEnum.Train, Validators.required)
        });
  }

  loggedIn(): boolean {
        let token = sessionStorage.getItem('id_token');
        if (!token) { return false; }
        return !this.jwtHelper.isTokenExpired(token);
  }

  onSubmit(event: Event): void {
    event.preventDefault();

    if (!this.loginForm.valid) {
        return;
    }

    this.inProgress = true;

    let formModel = this.loginForm.value as LoginModel;

    let response = this.authService.login(formModel.Username, formModel.Password, formModel.RememberMe);
    response.subscribe(
        resp => {
            this.inProgress = false;

            // TODO: Check BUS/TRAIN access rights

            if (resp.valueOf() === true) {
                this.globals.portalType = formModel.PortalType;
                localStorage.setItem('PortalType', formModel.PortalType === PortalTypeEnum.Bus ? 'Bus' : 'Train')
                this.router.navigate(['monitoring']);
            } else {
                this.errorMessage = 'Username or password is incorrect';
            }
        },
        err => {
            this.inProgress = false;
            if (err === 'access_denied') {
                this.errorMessage = 'Chybné uživatelské jméno nebo heslo.';
            } else if (err === 'server_error') {
                this.errorMessage = 'Nelze se připojit k LDAP serveru.';
            } else if (err === 'invalid_client') {
                this.errorMessage = 'Aplikace nemá dostatečné oprávnění.';
            } else {
                this.errorMessage = err;
            }
            console.error(err);
        });
    }

    setPortalType(portalType: PortalTypeEnum) {
        this.selectedPortalType = portalType;
        this.loginForm.controls['PortalType'].setValue(portalType);
    }

    ngAfterViewInit(): void {

      this.loginForm.controls['PortalType'].valueChanges.subscribe(v => {
            this.selectedPortalType = v;
      } );

      let formModel = this.loginForm.value as LoginModel;
      if (localStorage.getItem('PortalType') === 'Bus') {
        this.loginForm.controls['PortalType'].setValue(PortalTypeEnum.Bus);
      } else {
        this.loginForm.controls['PortalType'].setValue(PortalTypeEnum.Train);
      }

      // FIX: Expression has changed after it was checked.
      // See https://github.com/angular/angular/issues/6005
      this.changeDetectionRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/login/login.component.ts